import React, { useEffect } from 'react';
import Loading from '../../../../Components/Loading';
import FlatList from '../../../Base/Components/FlatList';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import DENTHistoryItem from './DENTHistoryItem/DENTHistoryItem';
import styles from './DENTHistory.module.scss';
import { useDentMedicalExaminationsQuery } from '../../../../graphql/graphql';
import { useFlatDataList } from '../../../Base/Hooks/useFlatDataList';

const WRAPPER_ID = 'dent-history';

const DENTHistory = () => {
	const { flatData, appendData, getNextPage, pagination, reset } =
		useFlatDataList();
	const { data, isLoading } = useDentMedicalExaminationsQuery({ pagination });

	useEffect(() => {
		appendData(data?.medicalExaminations?.data || []);
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			{/*<DENTHistoryFilter setFilter={setFilter} />*/}
			<ScrollContainer wrapperId={WRAPPER_ID} className={styles.list}>
				<FlatList
					onRefresh={reset}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={Boolean(data?.medicalExaminations?.meta?.hasNextPage)}
					scrollableTargetId={WRAPPER_ID}
					itemKey={'id'}
					renderItem={item => (
						<DENTHistoryItem key={item.id} item={item} reload={reset} />
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default DENTHistory;
